import { FlexPool } from 'hq/services/flex-pool-service.types';
import { z } from 'zod';

const baseEmployeeFieldsSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  infix: z.string().optional().nullable(),
  email: z.string(),
  phone: z.string().nullable(),
  profilePictureUrl: z.string().optional(),
  isOnboarded: z.boolean(),
});

export const employeeObjectSchema = baseEmployeeFieldsSchema.extend({
  state: z.string().optional(),
  location: z
    .object({
      address: z.string(),
      city: z.string().optional().nullable(),
      country: z.string().optional().nullable(),
      houseNumber: z.string().optional().nullable(),
      postalCode: z.string().optional().nullable(),
      street: z.string().optional().nullable(),
    })
    .optional(),
  allowResendTemporaryPassword: z.boolean().optional(),
  contractStartDate: z.string().nullable(),
  contractEndDate: z.string().nullable(),
  contractMinutes: z.number().nullable(),
});

export const partnerAndCompanyWorkerObjectSchema = baseEmployeeFieldsSchema.extend({
  level: z.enum(['EXPLORER', 'STARTER', 'CANDIDATE', 'WORKER']).nullable(),
  employmentType: z.string().nullable(),
  partnerId: z.string().optional().nullable(),
  partnerName: z.string().optional().nullable(),
});

export const employeeDetailSchema = z.object({
  ...employeeObjectSchema.shape,
  labourEngagementState: z.enum(['pending', 'approved', 'rejected', 'terminated']).nullable(),
});

export const employeesInfiniteResponseSchema = z.object({
  totalRows: z.number(),
  nextPage: z.number().optional(),
  previousPage: z.number().optional(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
  items: z.array(partnerAndCompanyWorkerObjectSchema),
});

export type EmployeeCreatePayload = {
  email: string;
  firstName: string;
  infix?: string;
  lastName: string;
  contractStartDate: string | undefined;
  contractEndDate: string | undefined;
  contractMinutes: number | null | undefined;
};

export type EmployeeUpdatePayload = {
  employeeFlexPools: FlexPool[];
  contractStartDate: string | undefined;
  contractEndDate: string | undefined;
  contractMinutes: number | null | undefined;
};

export type EmployeesInfiniteResponse = z.infer<typeof employeesInfiniteResponseSchema>;
export type EmployeeResponse = z.infer<typeof employeeDetailSchema>;
